/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { uploadToApi } from "venuescanner-js/services/api";
import { popup } from "venuescanner-js/vanilla/components/popup";
// eslint-disable-next-line no-unused-vars
import { node, jsxWatch } from "venuescanner-js/tools/jsx";
import { authService } from "venuescanner-js/services/auth";
import {
  BOOLEAN,
  STRING,
} from "venuescanner-js/vanilla/models/ObservablePropTypes";
import mimetype from "venuescanner-backend/app/classes/assets/mimetype";

const isAdmin = new BOOLEAN(null, false);
authService.isAdmin().then((admin) => isAdmin.set(admin));
const maxFileSize = 2 * 1048 * 1048;
const ProgressBar = ({ progress, isComplete }) => {
  jsxWatch("watch=(isComplete)");
  if (isComplete.valueOf()) return <vs-tick />;
  return (
    <div class="file-uploading-progess">
      <div
        style={{
          width: progress,
        }}
      ></div>
    </div>
  );
};
const FileConfirm = ({ show, confirm, cancel, message }) => {
  jsxWatch("watch=(show)");
  if (!show.valueOf()) return "";
  return (
    <div class="filedrop-alert filedrop-alert--warning">
      <div class="filedrop-alert--icon"></div>
      <div>
        <p>This file is bigger than 2MB</p>
        Therefore it might not be possible to sent it as an
        <br />
        email attachment.
      </div>
      <div class="filedrop-alert--warning__buttons">
        <button
          class="upload-btn"
          type="tiny"
          onClick={() => {
            show.set(false);
            confirm();
          }}
        >
          upload
        </button>
        <button
          class="cancel-btn"
          type="asLink"
          onClick={() => {
            show.set(false);
            cancel();
          }}
        >
          cancel
        </button>
      </div>
    </div>
  );
};
const FileUploading = ({
  filename,
  icon,
  progress,
  confirm,
  cancel,
  isComplete,
}) => {
  const showConfirm = new BOOLEAN(null, confirm !== null);
  return (
    <div class="file-uploading">
      <div class="file-uploading-details">
        <img src={icon} />
        <div>
          {filename}
          <ProgressBar progress={progress} isComplete={isComplete} />
        </div>
      </div>
      <FileConfirm
        show={showConfirm}
        confirm={confirm}
        cancel={cancel}
        message="This file is greater than 2mb, and therefore would not be sent as a file in any emails."
      />
    </div>
  );
};
export const FileDrop = ({ venue, filelist, isMobileDevice }) => {
  import("./fileDrop.scss");
  // const progress = new ObservableArray(null,{
  //   schema:{

  //   }
  // }
  const url = `attachment/upload${venue ? `/${venue._id || venue}` : ""}`;
  const upload = async (files) => {
    const completions = [];
    popup.new(
      <div>
        {files.map((file) => {
          const autoSend = file.size < maxFileSize;
          const progress = new STRING(null, "0%");
          const isComplete = new BOOLEAN(null, false);
          const icon = mimetype.getFile(
            file.name.replace(/^.*\.([^.]*$)/, (match, ext) => ext)
          );
          const responses = {
            cancel: () => {
              document.getElementById("fileElemForm").reset();
              popup.close();
            },
            complete: () => {},
          };
          const send = async () => {
            const res = await uploadToApi(url, file, (pc) => {
              progress.set(`${Math.round(pc)}%`);
              if (pc >= 100) {
                isComplete.set(true);
                responses.complete();
              }
            });
            if (res.data && res.data.data instanceof Array) {
              while (res.data.data.length) {
                const img = res.data.data.shift();
                filelist.push({ ...img, checked: true });
              }
            }
          };
          const div = (
            <FileUploading
              filename={file.name}
              isComplete={isComplete}
              icon={icon}
              progress={progress}
              confirm={autoSend ? null : send}
              cancel={responses.cancel}
            />
          );
          if (autoSend) {
            send();
          }
          completions.push(
            new Promise((resolve, reject) => {
              responses.cancel = reject;
              responses.complete = resolve;
            })
          );
          return div;
        })}
      </div>,
      { fullscreen: isMobileDevice }
    );
    await Promise.all(completions);
    popup.close();
  };
  const handleFiles = (files) => {
    if (files.length) upload([...files]);
  };
  const receiveFile = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const dt = e.dataTransfer;
    if (dt.files) handleFiles(dt.files);
  };
  let container = null;
  return (
    <div
      class="file-drop"
      ref={(el) => {
        container = el;
      }}
    >
      <form id="fileElemForm">
        <input
          type="file"
          id="fileElem"
          multiple
          accept="*"
          onChange={function () {
            handleFiles(this.files);
          }}
        />
        <label
          onDragover={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onDragenter={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (container) container.classList.add("drag-over");
          }}
          onDragleave={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (container) container.classList.remove("drag-over");
          }}
          onDrop={(e) => {
            e.preventDefault();
            e.stopPropagation();
            receiveFile(e);
            if (container) container.classList.remove("drag-over");
          }}
          for="fileElem"
        ></label>
      </form>
    </div>
  );
};
